import * as React from "react";

import { Button } from "@/components/ui/button";

import SampleAsset from "@/assets/sample-asset.png";
import { useNavigate } from "@tanstack/react-router";
import { MapPin, Camera, PlugZap } from "lucide-react";
import { CenteredInstallflowFrame } from "./centered-install-flow-frame";
import { AprovedInstallflowFrame } from "./aproved-install-flow-frame";

interface AuthProps extends React.HTMLAttributes<HTMLDivElement> {}

export function InstallNotStarted({ className }: AuthProps) {
  const navigate = useNavigate();
  async function onSubmit() {
    try {
      await navigate({ to: "/installFlow/asset-location" });
    } finally {
    }
  }

  return (
    <AprovedInstallflowFrame>
      <div className="flex flex-col gap-4 max-w-[342px]">
        <h2 className="text-xl font-bold text-black">
          To begin installing, let’s get the asset’s location.
        </h2>
        <div className="flex flex-col w-full items-center justify-center">
          <img
            src={SampleAsset}
            alt="Thalo Logo"
            className="w-full h-[232px] rounded-[25px]"
          />
          <div className="-mt-8 flex items-start gap-4 w-full max-w-[280px] bg-white rounded-xl p-6 shadow-sm z-10">
            <div className="flex flex-col items-center h-full">
              <div className="flex items-center justify-center h-[40px]">
                <span className="w-2 h-2 rounded-full bg-blue-500" />
              </div>
              <span className="flex-1 w-px bg-blue-200 my-1" />
              <div className="flex items-center justify-center h-5">
                <span className="w-2 h-2 rounded-full bg-gray-300" />
              </div>
              <span className="flex-1 w-px bg-gray-200 my-1" />
              <div className="flex items-center justify-center h-5">
                <span className="w-2 h-2 rounded-full bg-gray-300" />
              </div>
            </div>

            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-center gap-2 text-blue-600 h-[40px]">
                <MapPin className="w-6 h-6 mt-[2px]" />
                <div className="flex flex-col">
                  <span className="text-base font-bold uppercase tracking-wide text-blue-500">
                    Next
                  </span>
                  <span className="text-base font-bold text-gray-900">
                    Location info
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 text-gray-400 h-5">
                <Camera className="w-4 h-4" />
                <span className="text-base font-bold">Nameplate photo</span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 h-5">
                <PlugZap className="w-4 h-4" />
                <span className="text-base font-bold">Physical install</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-28 flex items-center">
        <Button
          variant="installFlow"
          className="w-full h-[50px] p-4 rounded-[25px] text-base font-semibold"
          onClick={onSubmit}
        >
          Continue
        </Button>
      </div>
    </AprovedInstallflowFrame>
  );
}
